export default (data: $TSMigrationFixMe) => ({
  ...data,

  camposPersonalizados: data?.camposPersonalizados?.map(
    ({ clave, valor, id, isNew }: $TSMigrationFixMe) => ({
      ...{
        clave,
        valor,
      },
      ...(!isNew && { id }),
    })
  ),
})
